import { Box, Container, Link, Typography, useTheme } from "@mui/material";
import ButtonComp from "../../../components/Button";
import { string } from "../../../constants/string";
import hero from "../../../assets/images/hero.svg";
import { useClaimTypeStore } from "../../../store/useClaimTypeStore";
import { useClaimFormStore } from "../../../store/useClaimFormStore";
import { usePolicyStore } from "../../../store/usePolicyStore";

export default function HeroSection(props: any) {
  const { onNavClick } = props;
  const setTypeOfClaim = useClaimFormStore((state) => state.setTypeOfClaim);
  const setPolicyData = usePolicyStore((state) => state.setPolicyData);
  const setClaimType = useClaimTypeStore((state) => state.setClaimType);

  const theme = useTheme();

  const handleClick = (value: "DEATH" | "TEN_PERCENT") => {
    setPolicyData(null);
    setTypeOfClaim(value);
    setClaimType(value);
    onNavClick(value);
  };

  return (
    <Box sx={{ width: "100%", height: { md: "100%" } }}>
      <Container
        maxWidth={false}
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          justifyContent: "center",
          px: { xs: 3, sm: 5, md: 10, lg: 16 },
          py: 4,
          backgroundColor: "background.paper",
        }}
      >
        {/* Left Section */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            mb: { xs: 4, md: 0 },
          }}
        >
          <Box
            sx={{
              maxWidth: 600,
              display: "flex",
              flexDirection: "column",
              textAlign: { xs: "center", md: "left" },
              gap: 3,
            }}
          >
            <Typography variant="h1" sx={{ color: theme.palette.primary.main }}>
              ICE-Claim
            </Typography>
            <Typography
              variant="h1"
              style={{
                color: theme.palette.text.primary,
                fontSize: "35px",
                lineHeight: 1.5,
              }}
            >
              Making your claims process easier and more efficient!
            </Typography>

            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: { xs: "center", md: "flex-start" },
                gap: 2,
              }}
            >
              <ButtonComp
                variant="contained"
                height={50}
                width={220}
                textTransform="none"
                onClick={() => handleClick("DEATH")}
              >
                {string.welcome.deathClaim}
              </ButtonComp>
              <ButtonComp
                variant="contained"
                height={50}
                width={220}
                textTransform="none"
                onClick={() => handleClick("TEN_PERCENT")}
              >
                {string.welcome.percentClaim}
              </ButtonComp>
            </Box>
            <Typography
              variant="body2"
              sx={{
                color: theme.palette.text.secondary,
                textAlign: { xs: "center", md: "left" },
              }}
            >
              By proceeding you accept the{" "}
              <Link
                href="https://selfservice.icebolethu.co.za/public/terms-and-conditions"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{ color: theme.palette.primary.main, fontWeight: 500 }}
              >
                Terms and Conditions
              </Link>
            </Typography>
          </Box>
        </Box>

        {/* Right Section - Image */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={hero}
            alt="Hero"
            sx={{
              maxWidth: { xs: "100%", sm: "80%", md: "100%", lg: "92%" },
              objectFit: "contain",
            }}
          />
        </Box>
      </Container>
    </Box>
  );
}
